import { ExternalLink } from "lucide-react";

// Official state sex-offender registry portals — every state + DC + territories.
// NSOPW (Dru Sjodin National Sex Offender Public Website) has NO public bulk API,
// and bulk-copying state registries is prohibited by most states' terms — so this
// directory hands officers each state's OFFICIAL live registry, one tap away.
const REGISTRIES = [
  ["AL", "Alabama", "https://app.alea.gov/Community/wfSexOffenderSearch.aspx"],
  ["AK", "Alaska", "https://dps.alaska.gov/SORWeb/"],
  ["AZ", "Arizona", "https://www.azdps.gov/services/public/offender"],
  ["AR", "Arkansas", "https://apps.ark.org/offender-search/"],
  ["CA", "California", "https://www.meganslaw.ca.gov/"],
  ["CO", "Colorado", "https://apps.colorado.gov/apps/dps/sor/"],
  ["CT", "Connecticut", "https://sexoffenderregistry.ct.gov/"],
  ["DE", "Delaware", "https://sexoffender.dsp.delaware.gov/"],
  ["DC", "District of Columbia", "https://mpdc.dc.gov/page/sex-offender-registry"],
  ["FL", "Florida", "https://offender.fdle.state.fl.us/offender/sops/home.jsf"],
  ["GA", "Georgia", "https://gbi.georgia.gov/services/georgia-sex-offender-registry"],
  ["HI", "Hawaii", "https://sexoffenders.ehawaii.gov/"],
  ["ID", "Idaho", "https://isp.idaho.gov/sor/"],
  ["IL", "Illinois", "https://isp.illinois.gov/Sor"],
  ["IN", "Indiana", "https://www.icrimewatch.net/indiana.php"],
  ["IA", "Iowa", "https://www.iowasexoffender.gov/"],
  ["KS", "Kansas", "https://www.kbi.ks.gov/registeredoffender/"],
  ["KY", "Kentucky", "https://kspsor.state.ky.us/"],
  ["LA", "Louisiana", "https://www.lsp.org/socpr/"],
  ["ME", "Maine", "https://www.maine.gov/sor/"],
  ["MD", "Maryland", "https://www.dpscs.state.md.us/sorSearch/"],
  ["MA", "Massachusetts", "https://www.mass.gov/orgs/sex-offender-registry-board"],
  ["MI", "Michigan", "https://mspsor.com/"],
  ["MN", "Minnesota", "https://coms.doc.state.mn.us/PublicViewer/"],
  ["MS", "Mississippi", "https://sor.mdps.ms.gov/"],
  ["MO", "Missouri", "https://web.mshp.dps.missouri.gov/MSHPWeb/PatrolDivisions/CRID/SOR/SORPage.html"],
  ["MT", "Montana", "https://app.doj.mt.gov/apps/svow/"],
  ["NE", "Nebraska", "https://sor.nebraska.gov/"],
  ["NV", "Nevada", "https://www.nvsexoffenders.gov/"],
  ["NH", "New Hampshire", "https://business.nh.gov/nsor/"],
  ["NJ", "New Jersey", "https://www.njsp.org/sex-offender-registry/"],
  ["NM", "New Mexico", "https://www.nmsexoffender.dps.nm.gov/"],
  ["NY", "New York", "https://www.criminaljustice.ny.gov/SomsSUBDirectory/search_index.jsp"],
  ["NC", "North Carolina", "https://sexoffender.ncsbi.gov/"],
  ["ND", "North Dakota", "https://sexoffender.nd.gov/"],
  ["OH", "Ohio", "https://www.icrimewatch.net/ohio.php"],
  ["OK", "Oklahoma", "https://sors.doc.state.ok.us/svor/f?p=119"],
  ["OR", "Oregon", "https://sexoffenders.oregon.gov/"],
  ["PA", "Pennsylvania", "https://www.pameganslaw.state.pa.us/"],
  ["RI", "Rhode Island", "https://sor.ri.gov/"],
  ["SC", "South Carolina", "https://scor.sled.sc.gov/"],
  ["SD", "South Dakota", "https://sor.sd.gov/"],
  ["TN", "Tennessee", "https://sor.tbi.tn.gov/"],
  ["TX", "Texas", "https://publicsite.dps.texas.gov/SexOffenderRegistry"],
  ["UT", "Utah", "https://sonar.utah.gov/"],
  ["VT", "Vermont", "https://vcic.vermont.gov/sor"],
  ["VA", "Virginia", "https://sex-offender.vsp.virginia.gov/sor/"],
  ["WA", "Washington", "https://www.waspc.org/sexoffenderinfo"],
  ["WV", "West Virginia", "https://apps.wv.gov/StatePolice/SexOffender/"],
  ["WI", "Wisconsin", "https://appsdoc.wi.gov/public"],
  ["WY", "Wyoming", "https://wysors.dci.wyo.gov/"],
  ["PR/GU/VI/AS/MP + Tribal", "US Territories & Tribes (via NSOPW)", "https://www.nsopw.gov/search-public-sex-offender-registries"],
];

export function StateRegistries() {
  return (
    <div data-testid="sor-state-directory" className="mt-4">
      <div className="bg-[#F59E0B] text-black font-mono text-[11px] font-bold px-3 py-1.5">
        STATE SEX OFFENDER REGISTRIES — ALL 50 STATES + DC + TERRITORIES (OFFICIAL LIVE PORTALS)
      </div>
      <div className="border border-[#2C2D35] border-t-0 p-3">
        <div className="font-mono text-[10px] text-[#9CA3AF] mb-2">
          NSOPW provides no public bulk API and state registries prohibit bulk copying — each link below opens that state's OFFICIAL live registry (always current, photos included). National name search: use the NSOPW search above.
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-1.5">
          {REGISTRIES.map(([abbr, name, url]) => (
            <a key={abbr} data-testid={`sor-state-${abbr.slice(0, 2)}`} href={url} target="_blank" rel="noreferrer"
              className="flex items-center gap-1.5 px-2 py-1.5 border border-[#2C2D35] bg-[#141518] hover:border-[#F59E0B] transition-colors">
              <span className="font-head font-bold text-[11px] text-[#F59E0B] w-7 shrink-0">{abbr.slice(0, 2)}</span>
              <span className="font-mono text-[10px] text-[#C9CDD4] truncate">{name}</span>
              <ExternalLink size={10} className="ml-auto text-[#4B5563] shrink-0" />
            </a>
          ))}
        </div>
      </div>
    </div>
  );
}
